export const PARTNER_NAME_MIN_LENGTH = 1;
export const PARTNER_NAME_MAX_LENGTH = 64;

/** Rejects any digit — checked before the structure regex to provide more specific error message. */
export const PARTNER_NAME_NO_NUMBERS_REGEX = /\d/;

/** Checks that all characters are valid (letters, spaces, hyphens, apostrophes) without enforcing structure.
 * We use this as a separate step so we can display a message like "Name contains invalid characters" instead of "Name is invalid"
 */
export const PARTNER_NAME_VALID_CHARS_REGEX = /^[\p{L}\-' \u2019]+$/u;

/** Rejects structural issues: leading/trailing separators or consecutive separators.
 * Separate final step to display a more generic error message like "Name is invalid"
 */
export const PARTNER_NAME_BAD_STRUCTURE_REGEX = /^[-' \u2019]|[-' \u2019]$|[-' \u2019]{2}/u;
